import { render, staticRenderFns } from "./CurrencyBaseInput.vue?vue&type=template&id=3fcc1880"
import script from "./CurrencyBaseInput.vue?vue&type=script&lang=js"
export * from "./CurrencyBaseInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports